<template>
  <div class="workbench">
    <!-- <div class="wordbench-top">
      <div class="wordbench-top-business">
        <div class="wordbench-top-business-title">常用模块</div>
        <blank height="1"></blank>
        <div class="business-scroll-x">
          <div class="wordbench-top-business-item">
            <div
              class="business-cont"
              v-for="(item, index) in appInfoList"
              :key="index"
              @click="goApp(item.path)"
            >
              <div class="business-imgbgc">
                <a-icon class="business-img" :type="item.imgField" />
              </div>
              <div class="business-name">{{ item.appName }}</div>
            </div>
          </div>
        </div>
      </div>
      <img class="wordbench-top-img" src="./img/wlogo.jpeg" alt />
    </div>
    <blank height="12"></blank> -->
    <div class="wordbench-middle" v-if="isHomePageIds">
      <div class="wordbench-middle-item" v-show="isHomePage(1)">
        <div class="wordbench-middle-item-top">
          <span class="wordbench-middle-item-top-name" @click="myMission('1')"
            >待办任务</span
          >
          <div
            class="work-msg"
            @click="myMission('1')"
            v-if="wordbrnchtotal > 0"
          >
            {{ wordbrnchtotal }}
          </div>
          <img
            class="wordbench-middle-item-top-img"
            src="./img/task1.png"
            alt
          />
        </div>
        <div class="wordbench-middle-item-cont">
          <blank height="23"></blank>
          <div
            class="wordbench-middle-item-cont-view"
            v-for="(ToDoTasks, index) in ToDoTasksData"
            :key="index"
          >
            <div
              class="wordbench-middle-item-cont-view-left"
              @click="goDetial(ToDoTasks.resp)"
            >
              <span class="Stick">[{{ ToDoTasks.appName }}]</span>
              <span :title="ToDoTasks.processName">{{
                ToDoTasks.processName
              }}</span>
            </div>
            <div
              class="wordbench-middle-item-cont-view-right"
              :title="ToDoTasks.createdDate"
            >
              {{ ToDoTasks.createdDate.substring(0, 10) }}
            </div>
          </div>
          <div
            v-if="wordbrnchtotalLoding"
            class="wordbench-middle-item-cont-loding"
          >
            <a-spin />
          </div>
          <a-empty
            v-if="wordbrnchtotal === 0 && wordbrnchtotalLoding == false"
          />
          <!-- 分页 -->
          <div v-if="false" class="wordbrnch-pageination">
            <a-pagination
              @change="onChangewordbrnch"
              size="small"
              :defaultPageSize="7"
              :total="wordbrnchtotal"
            />
          </div>
        </div>
      </div>
      <div class="wordbench-middle-item" v-show="isHomePage(2)">
        <div
          class="wordbench-middle-item-top"
          style="background-color: rgba(150, 193, 172, 1)"
        >
          <span class="wordbench-middle-item-top-name" @click="myMission('2')"
            >已办任务</span
          >
          <img
            class="wordbench-middle-item-top-img"
            src="./img/task2.png"
            alt
          />
        </div>
        <div class="wordbench-middle-item-cont">
          <blank height="23"></blank>
          <div
            class="wordbench-middle-item-cont-view"
            v-for="(Tasksistory, index) in TasksistoryData"
            :key="index"
          >
            <div
              class="wordbench-middle-item-cont-view-left"
              @click="openTask(Tasksistory.resp)"
            >
              <span
                class="state1 mr5"
                v-if="Tasksistory.resp.processStatus == 1"
              >
                审批中
              </span>
              <span
                class="state2 mr5"
                v-if="Tasksistory.resp.processStatus == 2"
              >
                已办结
              </span>
              <span class="Stick">[{{ Tasksistory.appName }}]</span>
              <span :title="Tasksistory.processName">{{
                Tasksistory.processName
              }}</span>
            </div>
            <div
              class="wordbench-middle-item-cont-view-right"
              :title="Tasksistory.createdDate"
            >
              {{ Tasksistory.createdDate.substring(0, 10) }}
            </div>
          </div>
          <div
            v-if="TasksistorytotalLoding"
            class="wordbench-middle-item-cont-loding"
          >
            <a-spin />
          </div>
          <a-empty
            v-if="Tasksistorytotal === 0 && TasksistorytotalLoding == false"
          />
        </div>
      </div>
      <div class="wordbench-middle-item" v-show="isHomePage(3)">
        <div
          class="wordbench-middle-item-top"
          style="background-color: #3296de"
        >
          <span class="wordbench-middle-item-top-name" @click="myMission('3')"
            >我的申请</span
          >
          <img
            class="wordbench-middle-item-top-img"
            src="./img/task4.png"
            alt
          />
        </div>
        <div class="wordbench-middle-item-cont">
          <blank height="25"></blank>
          <div
            class="wordbench-middle-item-cont-view"
            v-for="(i, indexKey) in activityProcessList"
            :key="indexKey"
          >
            <div
              class="wordbench-middle-item-cont-view-left"
              @click="openTask(i.resp)"
            >
              <span class="state1 mr5" v-if="i.resp.processStatus == 1">
                审批中
              </span>
              <span class="state2 mr5" v-if="i.resp.processStatus == 2">
                已办结
              </span>
              <span :title="i.processName">{{ i.processName }}</span>
            </div>
            <div
              class="wordbench-middle-item-cont-view-right"
              :title="i.createdDate"
            >
              {{ i.createdDate.substring(0, 10) }}
            </div>
          </div>

          <div
            v-if="activityProcessLoding"
            class="wordbench-middle-item-cont-loding"
          >
            <a-spin />
          </div>
          <a-empty
            v-if="activityProcesstotal === 0 && activityProcessLoding == false"
          />
        </div>
      </div>
      <div class="wordbench-middle-item" v-show="isHomePage(4)">
        <div
          class="wordbench-middle-item-top"
          style="background-color: rgba(231, 214, 202, 1)"
        >
          <span class="wordbench-middle-item-top-name" @click="myMission('4')"
            >公文</span
          >
          <img
            class="wordbench-middle-item-top-img"
            src="./img/task5.png"
            alt
          />
        </div>
        <div class="wordbench-middle-item-cont">
          <blank height="23"></blank>
          <div
            @click="officialListClick(i)"
            class="wordbench-middle-item-cont-view"
            v-for="i in officialList"
            :key="i.id"
          >
            <div class="wordbench-middle-item-cont-view-left">
              <span class="wordbench-unread" v-if="i.documentConsultStatus == 2"
                >未查阅</span
              >
              <span :title="i.title">{{ i.title }}</span>
            </div>
            <div
              class="wordbench-middle-item-cont-view-right"
              :title="i.createTime"
            >
              {{ i.createTime }}
            </div>
          </div>
          <div v-if="officialLoding" class="wordbench-middle-item-cont-loding">
            <a-spin />
          </div>
          <a-empty v-if="officialtotal === 0 && officialLoding == false" />
        </div>
      </div>
      <div class="wordbench-middle-item" v-show="isHomePage(5)">
        <div
          class="wordbench-middle-item-top"
          style="background-color: rgba(174, 155, 217, 1)"
        >
          <span class="wordbench-middle-item-top-name" @click="myMission('5')"
            >简报</span
          >
          <!-- <div class="work-msg" @click="myMission('6')">
            {{ getBriefingtotal }}
          </div>-->
          <img
            class="wordbench-middle-item-top-img"
            src="./img/task5.png"
            alt
          />
        </div>
        <div class="wordbench-middle-item-cont">
          <blank height="23"></blank>
          <div
            @click="getBriefingListClick(i.documentId)"
            class="wordbench-middle-item-cont-view"
            v-for="i in getBriefingList"
            :key="i.id"
          >
            <div class="wordbench-middle-item-cont-view-left">
              <span class="wordbench-unread" v-if="i.documentConsultStatus == 2"
                >未查阅</span
              >
              <span :title="i.title">{{ i.title }}</span>
            </div>
            <div
              class="wordbench-middle-item-cont-view-right"
              :title="i.createTime"
            >
              {{ i.createTime }}
            </div>
          </div>
          <div
            v-if="getBriefingLoding"
            class="wordbench-middle-item-cont-loding"
          >
            <a-spin />
          </div>
          <a-empty
            v-if="getBriefingtotal === 0 && getBriefingLoding == false"
          />
        </div>
      </div>
      <div class="wordbench-middle-item" v-show="isHomePage(6)">
        <div
          class="wordbench-middle-item-top"
          style="background-color: rgba(149, 153, 192, 1)"
        >
          <span class="wordbench-middle-item-top-name" @click="myMission('6')"
            >新闻</span
          >
          <!-- <div class="work-msg" @click="goList()">
            {{ newstotal }}
          </div>-->
          <img
            class="wordbench-middle-item-top-img"
            src="./img/task3.png"
            alt
          />
        </div>
        <div class="wordbench-middle-item-cont">
          <blank height="23"></blank>

          <div
            class="news-cont-view"
            v-for="i in newsList"
            :key="i.id"
            @click="newscontViewList(i.id)"
          >
            <div class="news-cont-view-top">{{ i.title }}</div>
            <div class="news-cont-view-bottom">
              <div class="news-cont-view-bottom-left">
                {{ i.source }}消息:{{ i.title }}
              </div>
              <div class="news-right" :title="i.createTime">
                {{ i.createTime }}
              </div>
            </div>
          </div>
          <div v-if="newsLoding" class="wordbench-middle-item-cont-loding">
            <a-spin />
          </div>
          <a-empty v-if="newstotal === 0 && newsLoding == false" />
        </div>
      </div>
      <div class="wordbench-middle-item" v-show="isHomePage(7)">
        <div
          class="wordbench-middle-item-top"
          style="background-color: rgba(149, 153, 192, 1)"
        >
          <span class="wordbench-middle-item-top-name" @click="myMission('7')"
            >我的整改任务</span
          >
          <img
            class="wordbench-middle-item-top-img"
            src="./img/task3.png"
            alt
          />
        </div>
        <div class="wordbench-middle-item-cont">
          <blank height="23"></blank>
          <div
            class="wordbench-middle-item-cont-view"
            v-for="(RectifyTask, index) in getRectifyTask"
            :key="index"
          >
            <div
              class="wordbench-middle-item-cont-view-left"
              @click="goTask(RectifyTask)"
              :title="
                RectifyTask.giveOrgName +
                '给您发了一条整改任务，请在' +
                RectifyTask.startTime +
                '-' +
                RectifyTask.endTime +
                '完成'
              "
            >
              <span class="Stick">{{ RectifyTask.giveOrgName }}</span>
              给您发了一条整改任务，请在{{ RectifyTask.startTime }}-{{
                RectifyTask.endTime
              }}完成。
            </div>
            <div
              class="wordbench-middle-item-cont-view-right"
              :title="RectifyTask.createTime"
            >
              {{ RectifyTask.createTime }}
            </div>
          </div>
          <div
            v-if="getRectifyTaskLoding"
            class="wordbench-middle-item-cont-loding"
          >
            <a-spin />
          </div>
          <a-empty
            v-if="getRectifyTasktotal === 0 && getRectifyTaskLoding == false"
          />
        </div>
      </div>
      <div class="wordbench-middle-item" v-show="getRemainder() == 2"></div>
    </div>
    <appfloor></appfloor>
  </div>
</template>

<script>
import { queryLoginUser, getMyTasks, getMyTasksistory } from '@/http/url'
import {
  officialDocumentMyOfficialDocument,
  briefingGetBreiefing,
  activityProcess,
  appInfo,
  briefingCreateWord,
  officialDocumentCreateWord,
  projectApplyCreateWord,
  getTheInformationRelease
} from '@/views/workbench/api/api'
import { getTask } from '@/views/standingBook/api/api'
import { mapState, mapActions } from 'vuex'
export default {
  data() {
    return {
      ToDoTasksData: [],
      TasksistoryData: [],
      wordbrnchPage: 1,
      wordbrnchtotal: 0,
      Tasksistorytotal: 0,
      newsList: [],
      newstotal: 0,
      officialList: [],
      officialtotal: 0,
      getBriefingList: [],
      getBriefingtotal: 0,
      getRectifyTask: [],
      getRectifyTasktotal: 0,
      wordbrnchtotalLoding: true,
      TasksistorytotalLoding: true,
      newsLoding: true,
      officialLoding: true,
      getBriefingLoding: true,
      getRectifyTaskLoding: true,
      activityProcessList: [],
      //activityProcessListWei:[],
      activityProcesstotal: 0,
      activityProcessLoding: true,
      callbacks: 1,
      appInfoList: [], // app业务列表
      HomePageIds: [], // 页面配置列表
      isHomePageIds: false
    }
  },
  // computed: {
  //   ...mapState({
  //     HomePageIds: (state) => state.app.HomePageIds //页面配置
  //     // 获取表单是否可编辑状态  false可编辑  true不可编辑
  //   })
  // },
  methods: {
    //获取当前模块总数 余数 如果等于2  需要填充一个模块  防止样式出问题
    getRemainder() {
      if (this.HomePageIds.length > 0) {
        return this.HomePageIds.length % 3
      } else {
        return 0
      }
    },
    // 获取是否存在当前模块
    isHomePage(HomePageId) {
      return this.HomePageIds.find((item) => {
        return item == HomePageId
      })
    },
    //我的申请
    examine() {
      this.$router.push({
        path: '/myMission',
        query: {
          callbacks: this.callbacks,
          myMission: '2'
        }
      })
    },
    callback(key) {
      // key 1已提交    0未提交
      this.callbacks = key
    },
    goList(tobIt) {
      this.$router.push('/newsList?tobIt=' + tobIt)
    },
    gomyTask() {
      //跳转我的整改任务
      this.$router.push('/myTask?tobIt')
    },
    // 跳转 我的任务
    myMission(m) {
      this.$router.push({
        path: '/myMission',
        query: {
          tobIt: m
        }
      })
    },
    // 待办任务分页
    onChangewordbrnch(page) {
      this.wordbrnchPage = page
      this.getMyTasksFn()
    },
    // 我的待办任务
    getMyTasksFn() {
      const params = {
        page: this.wordbrnchPage,
        size: 7
      }
      getMyTasks(params).then((res) => {
        if (res.data.code === 0) {
          this.wordbrnchtotalLoding = false
          this.ToDoTasksData = res.data.data
          this.wordbrnchtotal = res.data.count
        }
      })
    },
    // 我的已办任务
    getMyTasksistoryFn() {
      const params = {
        page: this.wordbrnchPage,
        size: 7
      }
      getMyTasksistory(params).then((res) => {
        if (res.data.code === 0) {
          this.TasksistorytotalLoding = false
          this.TasksistoryData = res.data.data
          this.Tasksistorytotal = res.data.count
        }
      })
    },
    // 新闻
    gettheInformationRelease() {
      const params = {
        page: 1,
        size: 4
      }
      getTheInformationRelease(params).then((res) => {
        if (res.data.code == 0) {
          this.newsLoding = false
          let resList = res.data
          this.newsList = resList.data
          this.newstotal = resList.count
        }
      })
    },
    // 我的整改任务
    getTaskList() {
      const params = {
        page: 1,
        size: 7
      }
      getTask(params).then((res) => {
        if (res.data.code == 0) {
          this.getRectifyTask = res.data.data
          this.getRectifyTasktotal = res.data.count
          this.getRectifyTaskLoding = false
        }
      })
    },
    goTask(record) {
      this.$router.push({
        path: '/standingBookDetails',
        query: {
          auditOrgId: record.giveOrgId,
          auditedOrgId: record.receiveOrgId,
          auditOrgName: record.giveOrgName,
          auditedOrgName: record.receiveOrgName,
          businessId: record.id
        }
      })
    },
    // 公文
    officialDocumentListGain() {
      officialDocumentMyOfficialDocument().then((res) => {
        if (res.data.code == 0) {
          this.officialLoding = false
          this.officialList = res.data.data
          this.officialtotal = res.data.count
        }
      })
    },
    officialListClick(i) {
      if (i.skipPageReqFlag == '/OfficialDocumentDetial') {
        //公文模块
        officialDocumentCreateWord({ id: i.documentId, workbench: 1 }).then(
          (res) => {
            if (res.data.code == 0) {
              // 查看
              let item = res.data.data
              if (item.fileformat == 'bpmn') {
                this.$message.error('该文件类型(bpmn)系统暂时不支持在线预览')
              } else {
                let Base64 = require('js-base64').Base64
                window.open(
                  item.kkFileUrl +
                    encodeURIComponent(Base64.encode(item.fileUrl))
                )
              }
              this.officialDocumentListGain()
            }
          }
        )
      } else if (i.skipPageReqFlag == '/ProjectApplicationDetial') {
        //项目申请模块
        projectApplyCreateWord({ id: i.documentId, workbench: 1 }).then(
          (res) => {
            if (res.data.code == 0) {
              // 查看
              let item = res.data.data
              if (item.fileformat == 'bpmn') {
                this.$message.error('该文件类型(bpmn)系统暂时不支持在线预览')
              } else {
                let Base64 = require('js-base64').Base64
                window.open(
                  item.kkFileUrl +
                    encodeURIComponent(Base64.encode(item.fileUrl))
                )
              }
              this.officialDocumentListGain()
            }
          }
        )
      } else if (i.skipPageReqFlag == '/InformTheForwardingDetial') {
        //公文转发模块
        this.$router.push({
          path: '/InformTheForwardingDetial',
          query: {
            id: i.documentId,
            workbench: 1,
            isEdit: 1
          }
        })
      }
    },
    // 简报
    getBriefingListGain() {
      briefingGetBreiefing().then((res) => {
        if (res.data.code == 0) {
          this.getBriefingLoding = false
          this.getBriefingList = res.data.data
          this.getBriefingtotal = res.data.count
        }
      })
    },
    getBriefingListClick(id) {
      briefingCreateWord({ id, workbench: 1 }).then((res) => {
        if (res.data.code == 0) {
          // 查看
          let item = res.data.data
          if (item.fileformat == 'bpmn') {
            this.$message.error('该文件类型(bpmn)系统暂时不支持在线预览')
          } else {
            let Base64 = require('js-base64').Base64
            window.open(
              item.kkFileUrl + encodeURIComponent(Base64.encode(item.fileUrl))
            )
          }
          this.getBriefingListGain()
        }
      })
    },
    //我的申请
    activityProcessGain(params, i) {
      let obj = params
      // 判断i得出已提交/未提交,给obj加上检索字段
      activityProcess(obj).then((res) => {
        if (res.data.code == 0) {
          this.activityProcessLoding = false
          this.activityProcessList = res.data.data // 已提交
          this.activityProcesstotal = res.data.count
        }
      })
    },
    // 去查看 审批流
    openTask(resp) {
      let path = resp.skipPageReqFlag
      let id = resp.businessKey
      let formStep = resp.formStep
      let currentStep = resp.currentStep
      let isEdit = resp.isEdit
      let taskId = resp.taskId
      let processInstanceId = resp.processInstanceId
      let showApproveBtn = 0
      let fromHomePage = 0
      this.$router.push({
        path,
        query: {
          id,
          currentStep,
          formStep,
          isEdit,
          taskId,
          showApproveBtn,
          fromHomePage
        }
      })
    },
    // 去办理 进入审批流
    goDetial(resp) {
      /*
      审批流
        表单可编辑步骤：currentStep    默认100全部表单。1当前是第一步，2当前是第二步
        表单步骤：formStep: 100 全表单 1 代表第一步骤 2 代表第二步骤
        是否可编辑：isEdit: 100和1不可编辑 0 可编辑
        显示审批按钮 showApproveBtn: 1
        是否来自工作台： fromHomePage: 0-是  1/null-否
      */
      let path = resp.skipPageReqFlag
      let id = resp.businessKey
      let formStep = resp.formStep
      let currentStep = resp.currentStep
      let isEdit = resp.isEdit
      let taskId = resp.taskId
      let processInstanceId = resp.processInstanceId
      let showApproveBtn = 1
      let fromHomePage = 0
      // this.$router.push({
      //   path,
      //   query: {
      //     id,
      //     currentStep,
      //     formStep,
      //     isEdit,
      //     taskId,
      //     showApproveBtn
      //   }
      // })

      const { href } = this.$router.resolve({
        path,
        query: {
          id,
          currentStep,
          formStep,
          isEdit,
          taskId,
          showApproveBtn,
          fromHomePage
        }
      })
      window.open(href, '_self')
    },
    // 新闻列表点击
    newscontViewList(id) {
      this.$router.push({
        path: '/newsDetial',
        query: {
          id
        }
      })
    },
    //app业务
    getappInfo() {
      appInfo().then((res) => {
        if (res.data.code == 0) {
          this.appInfoList = res.data.data
        }
      })
    },
    goApp(path) {
      this.$router.push({
        path
      })
    },
    //拉列表
    getList(type) {
      if (type == 1) {
        //代办
        this.getMyTasksFn()
      }
      if (type == 2) {
        //已办
        this.getMyTasksistoryFn()
      }
      if (type == 3) {
        //申请
        this.activityProcessGain({ page: 1, size: 7 }, 1) // 已提交
      }
      if (type == 4) {
        //公文
        this.officialDocumentListGain()
      }
      if (type == 5) {
        //简报
        this.getBriefingListGain()
      }
      if (type == 6) {
        //新闻
        this.gettheInformationRelease()
      }
      if (type == 7) {
        //我的整改任务
        this.getTaskList()
      }
    }
  },
  created() {
    // 获取用户信息
    queryLoginUser().then((res) => {
      if (res.data.code == 0) {
        this.$store.commit('set_userInfo', res.data.data)

        this.HomePageIds = this.$store.state.app.HomePageIds
        this.isHomePageIds = true
        this.HomePageIds.forEach((item, index) => {
          this.getList(item)
        })
      }
    })
  }
  // mounted() {
  //   // 简报
  //   this.getBriefingListGain()
  //   // 公文
  //   this.officialDocumentListGain()
  //   // 新闻
  //   this.gettheInformationRelease()
  //   // 我的待办任务
  //   this.getMyTasksFn()
  //   // 我的已办任务
  //   this.getMyTasksistoryFn()
  //   // 我的申请  条件筛选我的申请
  //   this.activityProcessGain({ page: 1, size: 7 }, 1) // 已提交
  //   //this.activityProcessGain({page:1,size:6},0)  // 未提交
  //   //获取常用模块列表
  //   this.getappInfo()
  //   //获取我的整改任务列表
  //   this.getTaskList()
  // }
}
</script>

<style lang="scss" scoped>
.workbench {
  margin: 24px 16px;
  .wordbench-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .wordbench-top-business {
      // width: 67.1%;
      width: 66.4%;
      font-size: 14px;
      .wordbench-top-business-title {
        background: #fff;
        height: 41px;
        color: rgba(128, 128, 128, 1);
        font-size: 16px;
        line-height: 41px;
        padding-left: 15px;
      }
      .business-scroll-x {
        padding: 0 20px;
        overflow-x: scroll;
        background: #fff;
      }
      .wordbench-top-business-item {
        background: #fff;
        height: 120px;
        display: flex;
        align-items: center;
        // justify-content: space-around;
        justify-content: flex-start;
        .business-cont {
          margin-right: 50px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          cursor: pointer;
          .business-imgbgc {
            width: 38px;
            height: 38px;
            background-color: rgba(2, 120, 254, 1);
            border-radius: 4px;
            display: flex;
            align-items: center;
            justify-content: center;
            .business-img {
              font-size: 20px;
              color: #fff;
            }
          }
          .business-name {
            // width: 55px;
            text-align: center;
            margin-top: 8px;
            height: 18px;
            color: rgba(56, 56, 56, 1);
            font-size: 12px;
            line-height: 18px;
            white-space: nowrap;
          }
        }
      }
    }
    .wordbench-top-img {
      width: 32.7%;
      // height: 162px;
      height: 179px;
    }
  }
  .wordbench-middle {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    .wordbench-middle-item {
      margin-bottom: 20px;
      background: #fff;
      width: 32.7%;
      .wordbench-middle-item-top {
        height: 74px;
        color: rgba(80, 80, 80, 1);
        background-color: #63bfca;
        position: relative;
        font-size: 19px;
        color: rgba(255, 255, 255, 1);
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .wordbench-middle-item-top-name {
          cursor: pointer;
          margin-left: 23px;
        }

        .wordbench-middle-item-top-img {
          position: absolute;
          bottom: 1px;
          right: 0;
          // width: 95px;
          height: 59px;
        }
      }
      .wordbench-middle-item-cont {
        height: 305px;
        color: rgba(80, 80, 80, 1);
        background-color: rgba(255, 255, 255, 1);
        font-size: 14px;
        position: relative;
        .wordbench-middle-item-cont-loding {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .wordbrnch-pageination {
          text-align: right;
          position: absolute;
          bottom: 10px;
          right: 0;
        }
        .wordbench-middle-item-cont-view {
          cursor: pointer;
          color: rgba(128, 128, 128, 1);
          height: 21px;
          margin: 0 10px 15px 10px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .wordbench-middle-item-cont-view-left {
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            word-break: break-all;
            padding-right: 20px;
            cursor: pointer;
          }
          .wordbench-middle-item-cont-view-right {
            min-width: 100px;
            // width: 120px;
            height: 21px;
            font-size: 14px;
            line-height: 21px;
            text-align: right;
            overflow: hidden;
          }
        }
        .news-cont-view {
          margin: 0 10px 15px 10px;
          cursor: pointer;
          .news-cont-view-top {
            color: rgba(56, 56, 56, 1);
            font-size: 12px;
            line-height: 18px;
            text-align: left;
            font-weight: bold;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
          }
          .news-cont-view-bottom {
            margin-top: 6px;
            height: 18px;
            color: rgba(128, 128, 128, 1);
            font-size: 12px;
            line-height: 18px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .news-cont-view-bottom-left {
              width: calc(100% - 100px);
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
            }
            .news-right {
              width: 135px;
              height: 18px;
              color: rgba(128, 128, 128, 1);
              font-size: 12px;
              line-height: 18px;
              text-align: center;
            }
          }
        }
      }
    }
  }
}
.work-msg {
  margin-left: 7px;
  width: 21px;
  height: 21px;
  color: rgba(255, 255, 255, 1);
  background-color: rgba(245, 87, 78, 1);
  border-radius: 11px;
  font-size: 13px;
  // line-height: 21px;
  border: rgba(255, 255, 255, 1) solid 1px;
  // text-align: center;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.wordbench-unread {
  margin-right: 10px;
  width: 44px;
  height: 21px;
  color: rgba(212, 48, 48, 1);
  background-color: rgba(255, 255, 255, 1);
  border: rgba(212, 48, 48, 1) solid 1px;
  border-radius: 4px;
  font-size: 13px;
  text-align: center;
}
.Stick {
  color: #808080 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/workbench/index.vue